module.exports = __webpack_public_path__ + "static/media/artist-rush-album-4.cd3691f8.jpg";